import { userAPI } from '@/services-ts/axios'
import type { IPayloadCompanySetting } from '@/types/Request'
import type { IDepartmentStore } from '@/types/Store/State'
import { defineStore } from 'pinia'
import {
  createSimpleListItem,
  deleteSimpleListItem,
  fetchSimpleList,
  updateSimpleListItem,
} from './simpleListHelpers'

export const useDepartmentStore = defineStore('department', {
  state: (): IDepartmentStore => ({
    departmentList: [],
  }),

  actions: {
    async GetDepartmentList(): Promise<void> {
      const list = await fetchSimpleList(() => userAPI.DepartmentServices.GetDepartmentList())
      if (list) this.departmentList = list
    },

    async CreateDepartment(Name: string): Promise<boolean> {
      const item = await createSimpleListItem(
        name => userAPI.DepartmentServices.CreateDepartment(name),
        Name,
      )
      if (item) this.departmentList.push(item)
      return !!item
    },

    async UpdateDepartment(payload: IPayloadCompanySetting): Promise<boolean> {
      const status = await updateSimpleListItem(
        p => userAPI.DepartmentServices.UpdateDepartment(p),
        payload,
      )
      if (status) {
        this.departmentList = this.departmentList.map(department =>
          department.id === payload.Id
            ? { ...department, name: payload.Name, firstValue: payload.Name }
            : department,
        )
      }
      return status
    },

    async DeleteDepartment(Id: string): Promise<void> {
      const status = await deleteSimpleListItem(
        id => userAPI.DepartmentServices.DeleteDepartment(id),
        Id,
      )
      if (status) {
        this.departmentList = this.departmentList.filter(department => department.id !== Id)
      }
    },
  },
})
